import { AttributeAPI } from "@griffingroupglobal/eslib-api";

const editAttributesHandler = async (props) => {
  // https://github.com/GriffinGroupGlobal/gpMS_Dispatcher/blob/feature/src/services/attribute_service.js#L251
  // bulk update does not require current list of attributes
  const response = await AttributeAPI.postWOP("$bulkupdate", {
    attributes: props.args.editedItems,
  });
  return response?.data;
};

export default editAttributesHandler;
